import { OrganizationKeyName } from "../../../model/Organization";

export const UPDATE_PRODUCT_CATEGORY_ORDER_FAIL =
  "SHOP:UPDATE_PRODUCT_CATEGORY_ORDER_FAIL";

export const updateProductCategoryOrderFailAction = (
  organization: OrganizationKeyName
) => ({
  type: UPDATE_PRODUCT_CATEGORY_ORDER_FAIL as typeof UPDATE_PRODUCT_CATEGORY_ORDER_FAIL,
  organization,
});

export type UpdateProductCategoryOrderFailAction = ReturnType<
  typeof updateProductCategoryOrderFailAction
>;
